<template>
  <main id="authorProgs" v-if="isAuthed" v-scroll="handleScroll">
    <Toolbars ref="toolbars"
      :status="config.status"
      @emit="emitted"
    />
    <v-list id="authorProgsTable" class="py-0 px-0 transparent content">
      <v-list-item fixed class="list-navigator px-0 primary blue-grey--text text--darken-3">
        <v-list-item-action class="mx-0">
          <v-btn icon text disabled color="transparent"></v-btn>
        </v-list-item-action>
        <v-list-item-content class="py-0">
          <v-row dense>
            <v-col class="text-center font-weight-black caption">出発日</v-col>
            <v-col class="text-center font-weight-black caption">顧客名</v-col>
            <v-col class="text-center font-weight-black caption">学校名</v-col>
            <v-col class="text-center font-weight-black caption">国</v-col>
            <v-col class="text-center font-weight-black caption">申込書送付</v-col>
            <v-col class="text-center font-weight-black caption">インボイス</v-col>
            <v-col class="text-center font-weight-black caption">入学許可書</v-col>
            <v-col class="text-center font-weight-black caption">学校送金</v-col>
            <v-col class="text-center font-weight-black caption">滞在先詳細</v-col>
            <v-col class="text-center font-weight-black caption">送迎詳細</v-col>
            <v-col class="text-center font-weight-black caption">フライト</v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <v-progress-linear indeterminate :color="isLoading ? 'secondary' : 'transparent'"></v-progress-linear>
      <template v-for="(item, idx) in getItems">
        <v-list-item :key="item.id" :id="item.id" class="pa-0">
          <v-list-item-action v-if="item.authed" class="mx-0">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on"
                  color="secondary"
                  @click="openFuncs(item.id)">
                  <v-icon small>fas fa-ellipsis-v</v-icon>
                </v-btn>
              </template>
              <span v-html="item.comment || '備考欄なし'" class="text-left"></span>
            </v-tooltip>
            <v-menu bottom right nudge-top="-56"
              v-model="store.funcs[idx]"
              :attach="`#${item.id}`">
              <v-list>
                <v-list-item @click.stop="open({ type: 'media', item: item })">
                  <v-list-item-icon><v-icon small>fal fa-folder</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title>書類フォルダ</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item @click.stop="open({ type: 'comment', item: item })">
                  <v-list-item-icon><v-icon small>fal fa-comment-alt-edit</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title>備考欄</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.status === 'active'" @click.stop="submit({ id: item.id, type: 'done' })" class="green--text text--darken-2">
                  <v-list-item-icon><v-icon small color="secondary">fal fa-check-circle</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title class="blue--text text--darken-2">完了処理する</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.status === 'done'" @click.stop="submit({ id: item.id, type: 'progress' })" class="blue--text">
                  <v-list-item-icon><v-icon small color="blue">fal fa-check-circle</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title class="blue--text text--darken-2">未完処理する</v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <v-list-item v-if="item.status === 'active'" @click.stop="submit({ id: item.id, type: 'cancel' })" class="red--text">
                  <v-list-item-icon><v-icon small color="red">fal fa-minus-circle</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title class="red--text">キャンセル処理する</v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
          <v-list-item-action v-else class="ma-0">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon text v-on="on"
                  color="secondary"
                  @click="open({ type: 'media', item })">
                  <v-icon small>fa-folder</v-icon>
                </v-btn>
              </template>
              <span>関連ファイル</span>
            </v-tooltip>
          </v-list-item-action>
          <v-list-item-content class="pa-0">
            <v-row dense>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'date', item: item })">{{ item.date }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'client', item: item })">{{ item.name.join(' ') }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'title', item: item })">{{ item.title }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'country', item: item })">{{ item.country }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" :class="item.post === '未完' ? 'grey--text text--darken-1' : 'text-center font-weight-bold'" :disabled="!item.authed" @click.stop="open({ type: 'post', item: item })" v-html="item.post"></v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" :class="item.invoice === '未完' ? 'grey--text text--darken-1' : 'text-center font-weight-bold'" :disabled="!item.authed" @click.stop="open({ type: 'invoice', item: item })">{{ item.invoice }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" :class="item.acceptance === '未完' ? 'grey--text text--darken-1' : 'text-center font-weight-bold'" :disabled="!item.authed" @click.stop="open({ type: 'acceptance', item: item })">{{ item.acceptance }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text block
                      class="caption px-0"
                      :class="item.transfers && item.transfers.length ? 'text-center font-weight-bold' : 'grey--text text--darken-1'"
                      :disabled="!item.authed"
                      v-html="item.transfer"
                    ></v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="jtem in item.transfers" :key="'transfer_' + jtem.id">
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">{{ jtem.content }}</v-list-item-subtitle>
                        <v-list-item-title>{{ jtem.option.type }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn icon small
                          color="secondary"
                          @click.stop="open({ type: 'transfer', item: item, sid: jtem.id })"
                        ><v-icon small>fal fa-pencil</v-icon></v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                  <v-list>
                    <v-list-item v-if="item.authed" class="blue--text" @click.stop="open({ type: 'transfer', item: item })">
                      <v-list-item-icon><v-icon small color="secondary">fal fa-plus</v-icon></v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="blue--text text--darken-2">送金を追加する</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action></v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" :class="item.stay === '未完' ? 'grey--text text--darken-1' : 'text-center font-weight-bold'" :disabled="!item.authed" @click.stop="open({ type: 'stay', item: item })" v-html="item.stay"></v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" :class="item.pickup === '未完' ? 'grey--text text--darken-1' : 'text-center font-weight-bold'" :disabled="!item.authed" @click.stop="open({ type: 'pickup', item: item })">{{ item.pickup }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" :class="item.flight === '未完' ? 'grey--text text--darken-1' : 'text-center font-weight-bold'" @click.stop="open({ type: 'flight', item: item })" v-html="item.flight"></v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
    <v-slide-y-transition>
      <v-footer app fixed
        v-if="isEnoughScrolled"
        class="px-3 transparent"
        style="top:60px;margin-left:auto;"
        :max-width="printFooterWidth"
        max-height="60">
      <v-list-item fixed class="list-navigator px-0 primary blue-grey--text text--darken-3">
        <v-list-item-action class="mx-0">
          <v-btn icon text disabled color="transparent"></v-btn>
        </v-list-item-action>
        <v-list-item-content class="py-0">
          <v-row dense>
            <v-col class="text-center font-weight-black caption">出発日</v-col>
            <v-col class="text-center font-weight-black caption">顧客名</v-col>
            <v-col class="text-center font-weight-black caption">学校名</v-col>
            <v-col class="text-center font-weight-black caption">国</v-col>
            <v-col class="text-center font-weight-black caption">申込書送付</v-col>
            <v-col class="text-center font-weight-black caption">インボイス</v-col>
            <v-col class="text-center font-weight-black caption">入学許可書</v-col>
            <v-col class="text-center font-weight-black caption">学校送金</v-col>
            <v-col class="text-center font-weight-black caption">滞在先詳細</v-col>
            <v-col class="text-center font-weight-black caption">送迎詳細</v-col>
            <v-col class="text-center font-weight-black caption">フライト</v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      </v-footer>
    </v-slide-y-transition>
    <ModalMedia ref="mediaEditor" />
    <ModalDate ref="dateEditor" @done="update" />
    <ModalTitle ref="titleEditor" @done="update" />
    <ModalCountry ref="countryEditor" @done="update" />
    <ModalType ref="typeEditor" @done="update" />
    <ModalPost ref="postEditor" @done="update" />
    <ModalInvoice ref="invoiceEditor" @done="update" />
    <ModalAcceptance ref="acceptanceEditor" @done="update" />
    <ModalTransfer ref="transferEditor" @done="update" />
    <ModalStay ref="stayEditor" @done="update" />
    <ModalPickup ref="pickupEditor" @done="update" />
    <ModalFlight ref="flightEditor" @done="update" />
    <ModalComment ref="commentEditor" @done="update" />
    <ModalConfirm ref="confirmer" />
  </main>
</template>

<script>
import _ from 'lodash'
import Toolbars from './toolbars'
import ModalMedia from './modals/media'
import ModalDate from './modals/date'
import ModalTitle from './modals/title'
import ModalCountry from './modals/country'
import ModalType from './modals/type'
import ModalPost from './modals/post'
import ModalInvoice from './modals/invoice'
import ModalAcceptance from './modals/acceptance'
import ModalTransfer from './modals/transfer'
import ModalStay from './modals/stay'
import ModalPickup from './modals/pickup'
import ModalFlight from './modals/flight'
import ModalComment from './modals/comment'
import ModalConfirm from '@/components/modals/confirm'

const DEFAULT = {
  LOADING: false,
  FILTERED: 'off',
  LIMIT: 20,
  ORDER: {
    FIELD: 'id',
    DIR: 'desc'
  }
}
export default {
  name: 'authorProgs',
  components: {
    Toolbars,
    ModalMedia,
    ModalDate,
    ModalTitle,
    ModalCountry,
    ModalType,
    ModalPost,
    ModalInvoice,
    ModalAcceptance,
    ModalTransfer,
    ModalStay,
    ModalPickup,
    ModalFlight,
    ModalComment,
    ModalConfirm
  },
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.LOADING,
          authed: false,
          scrolled: false
        },
        action: {
          active: false
        }
      },
      meta: {
        authors: {},
        arrangers: {},
        arrange: {
        }
      },
      store: {
        funcs: [],
        arranges: [],
        authors: [],
        arrangers: []
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    handleScroll: _.debounce(function (e) {
      this.$set(this.config.status, 'scrolled', window.scrollY > 200)
    }, 50),
    openFuncs: function (id) {
      let idx = this.store.arranges.findIndex(it => {
        return id === it.arrange.id
      })
      if (idx >= 0) {
        this.store.funcs.splice(idx, 1, true)
      }
    },
    init: function () {
      this.auth()
      // this.$nextTick(() => {
      //   this.loadLegacy()
      // })
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/get/items', fm, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'arranges', res.data.data.arranges)
              this.$set(this.store, 'funcs', Array(res.data.data.arranges.length).fill(false))
              this.$refs.toolbars.count(res.data.data.count)
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    update: function (res) {
      const { id, type, value } = res
      if (id && type && value != null) {
        let idx = this.store.arranges.findIndex(it => {
          return (it.arrange && it.arrange.id && it.arrange.id === id)
        })
        if (idx >= 0) {
          if (type === 'date') {
            this.$set(this.store.arranges[idx].arrange, 'start', value)
          } else if (type === 'title') {
            this.$set(this.store.arranges[idx].arrange, 'title', value)
          } else if (type === 'country') {
            this.$set(this.store.arranges[idx].arrange, 'country', value.country ? value.country : '')
            this.$set(this.store.arranges[idx].arrange, 'city', value.city ? value.city : '')
          } else if (type === 'type') {
            this.$set(this.store.arranges[idx].arrange, 'type', value)
          } else if (type === 'post') {
            this.$set(this.store.arranges[idx].arrange.post, 'content', value.date)
            this.$set(this.store.arranges[idx].arrange.post.option, 'online', value.online)
          } else if (type === 'invoice') {
            this.$set(this.store.arranges[idx].arrange.invoice, 'content', value)
          } else if (type === 'acceptance') {
            this.$set(this.store.arranges[idx].arrange.acceptance, 'content', value)
          } else if (type === 'transfer') {
            const { sid, date } = value
            let jdx = this.store.arranges[idx].arrange.transfers.findIndex(it => {
              return it.id === sid
            })
            if (jdx >= 0) {
              this.$set(this.store.arranges[idx].arrange.transfers[jdx], 'content', date)
              this.$set(this.store.arranges[idx].arrange.transfers[jdx], 'option', {
                type: value.type
              })
            } else {
              this.store.arranges[idx].arrange.transfers.push({
                id: sid,
                content: date,
                option: {
                  type: value.type
                }
              })
            }
          } else if (type === 'stay') {
            this.$set(this.store.arranges[idx].arrange.stay, 'content', value)
          } else if (type === 'stay-app') {
            this.$set(this.store.arranges[idx].arrange, 'stay.app', value)
          } else if (type === 'pickup') {
            this.$set(this.store.arranges[idx].arrange.pickup, 'content', value)
          } else if (type === 'flight') {
            this.$set(this.store.arranges[idx].arrange.flight, 'content', value.content ? value.content : '')
            this.$set(this.store.arranges[idx].arrange.flight, 'option', value.option ? JSON.parse(JSON.stringify(value.option)) : {
              media: '',
              final: {
                date: '',
                done: ''
              }
            })
          } else if (type === 'comment') {
            this.$set(this.store.arranges[idx].arrange.appendix, 'content', value)
          }
        }
      }
    },
    edit: function (item) {
      let idx = this.store.arranges.findIndex(it => {
        return !!(
          it.arrange &&
          it.arrange.id &&
          item.id === it.arrange.id
        )
      })
      if (idx >= 0) {
        this.$refs.commander.open()
      }
    },
    open: function (req) {
      const { type, item, sid } = req
      if (type && item && item.id) {
        let idx = this.store.arranges.findIndex(it => {
          return it.arrange.id === item.id
        })
        let dt = this.store.arranges[idx]
        if (type === 'client' && dt.client.id) {
          let resolve = this.$router.resolve({ path: '../client/' + dt.client.id })
          window.open(resolve.href, '_blank')
        } else if (type === 'media') {
          this.$refs.mediaEditor.open({
            aid: dt.arrange.aid,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            mid: dt.arrange.media.content
          })
        } else if (type === 'date') {
          this.$refs.dateEditor.open({
            id: dt.arrange.id,
            date: dt.arrange.start ? dt.arrange.start : ''
          })
        } else if (type === 'title') {
          this.$refs.titleEditor.open({
            id: dt.arrange.id,
            title: dt.arrange.title ? dt.arrange.title : ''
          })
        } else if (type === 'country') {
          this.$refs.countryEditor.open({
            id: dt.arrange.id,
            country: dt.arrange.country,
            city: dt.arrange.city
          })
        } else if (type === 'type') {
          this.$refs.typeEditor.open({
            id: dt.arrange.id,
            type: dt.arrange.type
          })
        } else if (type === 'post') {
          this.$refs.postEditor.open({
            id: dt.arrange.post.id,
            aid: dt.arrange.aid,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            date: dt.arrange.post.content,
            online: dt.arrange.post.option.online ? dt.arrange.post.option.online : '',
            mid: dt.arrange.media.content
          })
        } else if (type === 'invoice') {
          this.$refs.invoiceEditor.open({
            id: dt.arrange.invoice.id,
            aid: dt.arrange.aid,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            date: dt.arrange.invoice.content,
            mid: dt.arrange.media.content
          })
        } else if (type === 'acceptance') {
          this.$refs.acceptanceEditor.open({
            id: dt.arrange.acceptance.id,
            aid: dt.arrange.aid,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            date: dt.arrange.acceptance.content,
            mid: dt.arrange.media.content
          })
        } else if (type === 'transfer') {
          if (sid) {
            let jdx = dt.arrange.transfers.findIndex(it => {
              return it.id === sid
            })
            if (jdx >= 0) {
              let jtem = dt.arrange.transfers[jdx]
              this.$refs.transferEditor.open({
                id: jtem.id,
                cid: dt.arrange.id,
                clientId: dt.client.id,
                type: jtem.option && jtem.option.type ? jtem.option.type : '',
                date: jtem.content
              })
            }
          } else {
            this.$refs.transferEditor.open({
              id: '',
              cid: dt.arrange.id,
              clientId: dt.client.id,
              type: '',
              date: ''
            })
          }
        } else if (type === 'stay') {
          this.$refs.stayEditor.open({
            id: dt.arrange.stay.id,
            aid: dt.arrange.aid,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            date: dt.arrange.stay.content,
            mid: dt.arrange.media.content
          })
        } else if (type === 'pickup') {
          this.$refs.pickupEditor.open({
            id: dt.arrange.pickup.id,
            aid: dt.arrange.aid,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            date: dt.arrange.pickup.content,
            mid: dt.arrange.media.content
          })
        } else if (type === 'flight') {
          this.$refs.flightEditor.open({
            id: dt.arrange.flight.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            mid: dt.arrange.flight.option.media,
            comment: dt.arrange.flight.content,
            final: {
              date: (dt.arrange.flight.option && dt.arrange.flight.option.final && dt.arrange.flight.option.final.date) ? dt.arrange.flight.option.final.date : '',
              done: (dt.arrange.flight.option && dt.arrange.flight.option.final && dt.arrange.flight.option.final.done) ? dt.arrange.flight.option.final.done : ''
            }
          })
        } else if (type === 'comment') {
          this.$refs.commentEditor.open({
            id: dt.arrange.appendix.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: item.authed,
            comment: dt.arrange.appendix.content
          })
        }
      }
    },
    submit: function (req) {
      const { id, type } = req
      const types = {
        done: {
          title: '完了処理する',
          message: 'この手配を完了済みにしてもよろしいですか？',
          colors: {
            title: 'green white--text'
          },
          req: {
            id: id,
            status: 'done'
          }
        },
        cancel: {
          title: 'キャンセル処理する',
          message: 'この手配をキャンセルしてもよろしいですか？',
          colors: {
            title: 'red white--text'
          },
          req: {
            id: id,
            status: 'cancel'
          }
        },
        progress: {
          title: '未完処理する',
          message: 'この手配を未完状態に戻してもよろしいですか？',
          req: {
            id: id,
            status: 'active'
          }
        }
      }
      if (types[type]) {
        const dt = types[type]
        this.$refs.confirmer.open(Object.assign(dt, {
          callback: () => {
            const { id, status } = dt.req
            this.$set(this.config.status, 'loading', true)
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(this.$url.api + 'progs/update/item', {
                id: id,
                status: status
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  this.$nextTick(() => {
                    const fm = this.$refs.toolbars.getForm()
                    console.log(fm)
                    this.get(fm)
                  })
                }
                this.$set(this.config.status, 'loading', false)
              }).catch(err => {
                console.log(err)
                this.$set(this.config.status, 'loading', false)
              })
            })
          }
        }))
      }
    },
    loadLegacy: function () {
      this.$refs.media_aid.value = this.$store.getters['author/get']('userid')
      this.$nextTick(() => {
        this.$refs.legacyForm.submit()
      })
    }
  },
  computed: {
    printURL () {
      return 'https://www.sasmango.com/sas/author/scoola?init'
    },
    isAuthed () {
      return this.config.status.authed
    },
    isEnoughScrolled () {
      return this.config.status.scrolled
    },
    isDevMode () {
      return this.$store.getters['author/get']('dev')
    },
    isLoading () {
      return this.config.status.loading
    },
    getItems () {
      return this.store.arranges.map(it => {
        const { arrange, client } = it
        const { id, aid, start, title, country, type, status, post, invoice, acceptance, stay, pickup, transfers, flight, appendix } = arrange
        const stayApp = arrange['stay.app']
        return {
          id: id,
          cid: client.id,
          authed: aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer'),
          aid: aid,
          date: start ? this.$moment(start).format('YY/MM/DD') : '',
          name: client.name.split(','),
          title: title,
          country: this.$mango.nations[country] ? this.$mango.nations[country] : country,
          type: this.$mango.arrange.types[type] ? this.$mango.arrange.types[type] : type,
          status: status,
          post: [
            (post && post.content) ? this.$moment(post.content).format('YY/MM/DD') : '未完'
          ].concat((post && post.option && post.option.online) ? ['オンライン'] : []).join('<br />'),
          invoice: (invoice && invoice.content) ? this.$moment(invoice.content).format('YY/MM/DD') : '未完',
          acceptance: (acceptance && acceptance.content) ? this.$moment(acceptance.content).format('YY/MM/DD') : '未完',
          stay: [].concat(
            (stay && stay.content) ? [this.$moment(stay.content).format('YY/MM/DD')] : ['未完'],
            (stayApp && stayApp.option.status === 'active') ? ['滞在手配中'] : ((stayApp && stayApp.option.status === 'done') ? ['滞在手配完了'] : [])
          ).join('<br />'),
          pickup: (pickup && pickup.content) ? this.$moment(pickup.content).format('YY/MM/DD') : '未完',
          transfers: transfers.map(it => {
            return {
              id: it.id,
              content: it.content ? this.$moment(it.content).format('YY/MM/DD') : '',
              option: it.option ? it.option : {
                type: ''
              }
            }
          }),
          transfer: transfers && transfers.length ? (transfers.length === 1 ? `${transfers[0].content ? this.$moment(transfers[0].content).format('YY/MM/DD') : ''}<br />${transfers[0].option.type}` : `送金（${transfers.length}）`) : '未完',
          flight: flight ? ((flight.option && flight.option.final && flight.option.final.done) ? 'ファイナル完了' : ((flight.option.final && flight.option.final.date) ? ('ファイナル期日<br />' + this.$moment(flight.option.final.date).format('YY/MM/DD')) : (flight.content ? '予約済み' : '未完'))) : '未完',
          comment: (appendix && appendix.content) ? appendix.content.replace(/\r?\n/g, '<br />') : ''
        }
      })
    },
    printFooterWidth () {
      return this.$vuetify.breakpoint.lgAndUp ? (window.innerWidth - 256) : null
    }
  }
}
</script>

<style lang="scss">
#authorProgs {
  .content {
    .row {
      width: 100%;
      text-align: center;
      .col {
        display: inline-flex;
        justify-content: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .v-btn {
          margin: 0;
          padding: 0 .5rem;
          width: 100%;
          min-width: 0;
          justify-content: center;
          .v-btn__content {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
